import {
  type ChartAggregateFunctionType,
  type SchemaColumnSelectOption,
} from '@blaze-shared/elements-domain';

export function createSelectOptions(options: ChartAggregateFunctionType[]): {
  value: ChartAggregateFunctionType;
  label: string;
}[] {
  return options.map((value) => ({
    value,
    label: value === 'AVG' ? 'AVERAGE' : value,
  }));
}

export function preventSelectingColumnForCount(
  option: SchemaColumnSelectOption,
  index: number,
): boolean {
  if (option.value === 'COUNT' && index === 0) {
    return false;
  }
  return true;
}

export function onlyDateWithMultipleLevels(
  option: SchemaColumnSelectOption,
  _index: number,
): boolean {
  if (option.dataType === 'Date' || option.dataType === 'DateTime') {
    return true;
  }
  return false;
}
